import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(handleUpdate),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(watchAddGlobalItems),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(watchRemoveGlobalItems),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(watchUndoGlobalItems);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { take, put, call, fork, select } from 'redux-saga/effects';
import makeApiRequest from '../../../utils/makeApiRequest';
import { ADD_GLOBAL_ITEMS, REMOVE_GLOBAL_ITEMS, UNDO_GLOBAL_ITEMS, updateGlobalItemsRequest, updateGlobalItemsFailure, addGlobalItemsSuccess, removeGlobalItemsSuccess, undoGlobalItemsSuccess } from '../../../redux/globalList/updateItems';
import { queryUpdateItem } from '../../../utils/gql-queries';
import flattenQuery from '../../../utils/flattenQuery'; // -------------------------------------------------
// WORKER SAGAS
// -------------------------------------------------

export function handleUpdate(request) {
  var payload;
  return _regeneratorRuntime.wrap(function handleUpdate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(updateGlobalItemsRequest(request));

        case 2:
          _context.prev = 2;
          _context.next = 5;
          return call(makeApiRequest, {
            methodType: 'post',
            url: '/wishlist-service/gql-wishlist',
            body: request.body
          });

        case 5:
          payload = _context.sent;
          _context.t0 = request.actionType;
          _context.next = _context.t0 === ADD_GLOBAL_ITEMS ? 9 : _context.t0 === REMOVE_GLOBAL_ITEMS ? 17 : _context.t0 === UNDO_GLOBAL_ITEMS ? 25 : 33;
          break;

        case 9:
          if (!payload.data.data.AddWishlistItem) {
            _context.next = 14;
            break;
          }

          _context.next = 12;
          return put(addGlobalItemsSuccess(_objectSpread(_objectSpread({}, payload.data.data.AddWishlistItem), {}, {
            errors: payload.data.errors
          })));

        case 12:
          _context.next = 16;
          break;

        case 14:
          _context.next = 16;
          return put(updateGlobalItemsFailure(payload.data.errors[0]));

        case 16:
          return _context.abrupt("break", 34);

        case 17:
          if (!payload.data.data.RemoveWishlistItem) {
            _context.next = 22;
            break;
          }

          _context.next = 20;
          return put(removeGlobalItemsSuccess(_objectSpread(_objectSpread({}, payload.data.data.RemoveWishlistItem), {}, {
            errors: payload.data.errors
          })));

        case 20:
          _context.next = 24;
          break;

        case 22:
          _context.next = 24;
          return put(updateGlobalItemsFailure(payload.data.errors[0]));

        case 24:
          return _context.abrupt("break", 34);

        case 25:
          if (!payload.data.data.UndoWishlistItem) {
            _context.next = 30;
            break;
          }

          _context.next = 28;
          return put(undoGlobalItemsSuccess(_objectSpread(_objectSpread({}, payload.data.data.UndoWishlistItem), {}, {
            errors: payload.data.errors
          })));

        case 28:
          _context.next = 32;
          break;

        case 30:
          _context.next = 32;
          return put(updateGlobalItemsFailure(payload.data.errors[0]));

        case 32:
          return _context.abrupt("break", 34);

        case 33:
          return _context.abrupt("break", 34);

        case 34:
          _context.next = 40;
          break;

        case 36:
          _context.prev = 36;
          _context.t1 = _context["catch"](2);
          _context.next = 40;
          return put(updateGlobalItemsFailure(_context.t1));

        case 40:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[2, 36]]);
} // -------------------------------------------------
// WATCHER SAGAS
// -------------------------------------------------

export var getGlobalList = function getGlobalList(state) {
  return state.globalList.data;
};
export function watchAddGlobalItems() {
  var _yield$take, request, requestQuery, globalList, body;

  return _regeneratorRuntime.wrap(function watchAddGlobalItems$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!true) {
            _context2.next = 14;
            break;
          }

          _context2.next = 3;
          return take(ADD_GLOBAL_ITEMS);

        case 3:
          _yield$take = _context2.sent;
          request = _yield$take.request;
          requestQuery = _yield$take.requestQuery;
          _context2.next = 8;
          return select(getGlobalList);

        case 8:
          globalList = _context2.sent;
          body = flattenQuery(queryUpdateItem('AddWishlistItem', globalList.wishlists[0].id || null, request, requestQuery.query || 'wid items {partNumber}'));
          _context2.next = 12;
          return fork(handleUpdate, {
            body: body,
            items: request,
            actionType: ADD_GLOBAL_ITEMS
          });

        case 12:
          _context2.next = 0;
          break;

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function watchRemoveGlobalItems() {
  var _yield$take2, request, requestQuery, globalList, body;

  return _regeneratorRuntime.wrap(function watchRemoveGlobalItems$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!true) {
            _context3.next = 14;
            break;
          }

          _context3.next = 3;
          return take(REMOVE_GLOBAL_ITEMS);

        case 3:
          _yield$take2 = _context3.sent;
          request = _yield$take2.request;
          requestQuery = _yield$take2.requestQuery;
          _context3.next = 8;
          return select(getGlobalList);

        case 8:
          globalList = _context3.sent;
          body = flattenQuery(queryUpdateItem('RemoveWishlistItem', globalList.wishlists[0].id, request, requestQuery.query || 'wid items {partNumber}'));
          _context3.next = 12;
          return fork(handleUpdate, {
            body: body,
            items: request,
            actionType: REMOVE_GLOBAL_ITEMS
          });

        case 12:
          _context3.next = 0;
          break;

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function watchUndoGlobalItems() {
  var _yield$take3, request, requestQuery, globalList, body;

  return _regeneratorRuntime.wrap(function watchUndoGlobalItems$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (!true) {
            _context4.next = 14;
            break;
          }

          _context4.next = 3;
          return take(UNDO_GLOBAL_ITEMS);

        case 3:
          _yield$take3 = _context4.sent;
          request = _yield$take3.request;
          requestQuery = _yield$take3.requestQuery;
          _context4.next = 8;
          return select(getGlobalList);

        case 8:
          globalList = _context4.sent;
          body = flattenQuery(queryUpdateItem('UndoWishlistItem', globalList.wishlists[0].id, request, requestQuery.query || 'wid items {partNumber dateAdded}'));
          _context4.next = 12;
          return fork(handleUpdate, {
            body: body,
            items: request,
            actionType: UNDO_GLOBAL_ITEMS
          });

        case 12:
          _context4.next = 0;
          break;

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}